import { Box, Button, Tooltip, Typography } from '@mui/material';
import BookmarksIcon from '@mui/icons-material/Bookmarks';

export const PresetAddElementButton = ({
  label,
  onClick,
  size,
  sizePx,
  sx,
  addLabel,
  noBlur,
  className = '',
}) => {
  return (
    <Tooltip title={label}>
      <Box className={className + ' flex rounded-lg '}>
        <Button
          onClick={(e) => {
            e.stopPropagation(); // prevents card navigation
            onClick(e); // calls original click handler
          }}
          className="no-nav opacity-60 w-full flex "
          variant="contained"
          color="secondary"
          sx={sx}
          disableElevation
        >
          <BookmarksIcon
            className="opacity-80"
            sx={{
              fontSize: sizePx ? sizePx : size === 'small' ? '25px' : '60px',
              marginRight: addLabel ? '10px' : '0px',
            }}
          />
          {addLabel}
        </Button>
      </Box>
    </Tooltip>
  );
};
